import React, { useEffect, useState } from "react";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import useHttp from "../../../../hook/use-http";
import NoTableData_Jupiter from "./NoTableData_Jupiter";

import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../../redux/userSlice";

export default function ChargingInterruptionDuration_Jupiter({ gloablfilter, singleVinSelected }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [vehiclesInterruption, setVehiclesInterruption] = useState([]);
  const [vehiclesDuration, setVehiclesDuration] = useState([]);
  const [durationToggle, setDurationToggle] = useState(false)
  const [TBSelected, setTBSelected] = useState('ttt')
  const [interruptionToggle, setInterruptionToggle] = useState(false)

  const handleChangeInterruption = (e) => {
    setInterruptionToggle(e.target.checked)
    if (gloablfilter.VIN_NUM.length === 1) {
      if (e.target.checked === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_interruption_vehicle_slow", body: { filterdata: gloablfilter } }, charge_interruption)
      } else {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_interruption_vehicle_fast", body: { filterdata: gloablfilter } }, charge_interruption)
      }
    } else {
      if (e.target.checked === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_interruption_fleet_slow", body: { filterdata: gloablfilter } }, charge_interruption)
      } else {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_interruption_fleet_fast", body: { filterdata: gloablfilter } }, charge_interruption)
      }
    }
  };

  const charge_interruption = (data) => {
    setVehiclesInterruption(data);
  }

  useEffect(() => {
    if (gloablfilter.VIN_NUM.length === 1) {
      if (interruptionToggle === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_interruption_vehicle_slow", body: { filterdata: gloablfilter } }, charge_interruption)
      } else {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_interruption_vehicle_fast", body: { filterdata: gloablfilter } }, charge_interruption)
      }
      if (TBSelected === "ttt" && durationToggle === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_top_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (TBSelected === "ttt" && durationToggle === true) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_top_fast", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (TBSelected === "bbb" && durationToggle === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_bottom_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_bottom_fast", body: { filterdata: gloablfilter } }, charge_duration)
      }
    } else {
      fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_interruption_fleet_slow", body: { filterdata: gloablfilter } }, charge_interruption)
      fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_fleet_top_slow", body: { filterdata: gloablfilter } }, charge_duration)
    }
  }, [gloablfilter])

  const charge_duration = (data) => {
    setVehiclesDuration(data);
  }

  const handleChangeDuration = (e) => {
    setDurationToggle(e.target.checked)
    if (gloablfilter.VIN_NUM.length === 1) {
      if (TBSelected === "ttt" && e.target.checked === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_top_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (TBSelected === "ttt" && e.target.checked === true) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_top_fast", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (TBSelected === "bbb" && e.target.checked === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_bottom_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_bottom_fast", body: { filterdata: gloablfilter } }, charge_duration)
      }
    } else {
      if (TBSelected === "ttt" && e.target.checked === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_fleet_top_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (TBSelected === "ttt" && e.target.checked === true) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_fleet_top_fast", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (TBSelected === "bbb" && e.target.checked === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_fleet_bottom_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_fleet_bottom_fast", body: { filterdata: gloablfilter } }, charge_duration)
      }
    }
  };

  const [TBText, setTBText] = useState("Top")
  const changeTB = (selectOp) => {
    setTBSelected(selectOp);
    (selectOp === "ttt") ? setTBText("Top") : setTBText("Bottom")
    if (gloablfilter.VIN_NUM.length === 1) {
      if (selectOp === "ttt" && durationToggle === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_top_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (selectOp === "ttt" && durationToggle === true) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_top_fast", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (selectOp === "bbb" && durationToggle === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_bottom_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_vehicle_bottom_fast", body: { filterdata: gloablfilter } }, charge_duration)
      }
    } else {
      if (selectOp === "ttt" && durationToggle === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_fleet_top_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (selectOp === "ttt" && durationToggle === true) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_fleet_top_fast", body: { filterdata: gloablfilter } }, charge_duration)
      } else if (selectOp === "bbb" && durationToggle === false) {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_fleet_bottom_slow", body: { filterdata: gloablfilter } }, charge_duration)
      } else {
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/charge_duration_fleet_bottom_fast", body: { filterdata: gloablfilter } }, charge_duration)
      }
    }
  }

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    (loggedInUser.flagForHideShow === "FLEETEV") ?
      <div className="col-lg-3 col-md-6 col-sm-12">
        <div className="chargingChartbox highlightTableSec">
          <div className="v-title chargingTitleChart">
            <div className="row p-2">
              <div className="col-lg-6 col-md-8 col-sm-6 col-6">
                <div className=""><b>{TBText} 10 vehicles with charge duration</b></div>
              </div>
              <div className="col-lg-6 col-md-4 col-sm-6 col-6">
                <div className="row">
                  <div className="col-lg-7 col-md-7 col-sm-7 col-7" style={{ paddingLeft: '0px' }}>
                    <div className="dropdownSelectBtnCharging">
                      <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeTB(event.target.value)}
                        value={TBSelected}>
                        <option value="ttt">Top</option>
                        <option value="bbb">Bottom</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-5 col-sm-5 col-5" style={{ paddingLeft: '0px' }}>
                    <div className="toggleBtn pt-0">
                      <div className="toggle-button-cover">
                        <div className="button-cover">
                          <div className="buttonbtn r" id="button-1">
                            <input type="checkbox" className="checkbox" onChange={handleChangeDuration} />
                            <div className="knobs" />
                            <div className="layer" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tableContent px-2" style={{ overflowY: 'scroll', height: '250px' }}>
            <table className="table table-striped">
              <thead style={{ backgroundColor: '#358696', color: '#fff' }}>
                <tr>
                  <th scope="col">Vin</th>
                  <th scope="col">Mins</th>
                </tr>
              </thead>
              <tbody>
                {(vehiclesDuration.length == 0) ? <NoTableData_Jupiter /> : vehiclesDuration.map(x => {
                  return (<tr key={x.key.vehicleId}>
                    <td scope="row" className="hand_geture" onClick={() => singleVinSelected(x.key.vehicleId)}>{x.key.vehicleId}</td>
                    <td>{x.chargeDurationInMin.value}</td>
                  </tr>)
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div> :
      <div className="col-lg-7">
        <div className="row">
          <div className="col-lg-6 mb-3">
            <div className="chargingChartbox highlightTableSec">
              <div className="v-title chargingTitleChart">
                <div className="row p-2">
                  <div className="col-lg-7 col-md-8 col-sm-8 col-8">
                    <div className=""><b>Top 10 vehicles with charge interruption</b></div>
                  </div>
                  <div className="col-lg-5 col-md-4 col-sm-4 col-4">
                    <div className="toggleBtn pt-0">
                      <div className="toggle-button-cover">
                        <div className="button-cover">
                          <div className="buttonbtn r" id="button-1">
                            <input type="checkbox" className="checkbox" onChange={handleChangeInterruption} />
                            <div className="knobs" />
                            <div className="layer" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tableContent px-2" style={{ overflowY: 'scroll', height: '250px' }}>
                <table className="table table-striped">
                  <thead style={{ backgroundColor: '#358696', color: '#fff' }}>
                    <tr>
                      <th scope="col">Vin</th>
                      <th scope="col">Count</th>
                    </tr>
                  </thead>
                  <tbody>

                    {(vehiclesInterruption.length == 0) ? <NoTableData_Jupiter /> : vehiclesInterruption.map(x => {
                      return (<tr key={x.key.vehicleId}>
                        <td scope="row" className="hand_geture" onClick={() => singleVinSelected(x.key.vehicleId)}>{x.key.vehicleId}</td>
                        <td>{x.NoOfInterrupt.value}</td>
                      </tr>)
                    })}

                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="chargingChartbox highlightTableSec">
              <div className="v-title chargingTitleChart">
                <div className="row p-2">
                  <div className="col-lg-5 col-md-8 col-sm-5 col-5">
                    <div className=""><b>{TBText} 10 vehicles with charge duration</b></div>
                  </div>
                  <div className="col-lg-7 col-md-4 col-sm-7 col-7">
                    <div className="row">
                      <div className="col-lg-7 col-md-7 col-sm-7 col-7">
                        <div className="dropdownSelectBtnCharging">
                          <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeTB(event.target.value)}
                            value={TBSelected}>
                            <option value="ttt">Top</option>
                            <option value="bbb">Bottom</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-5 col-md-5 col-sm-5 col-5">
                        <div className="toggleBtn pt-0">
                          <div className="toggle-button-cover">
                            <div className="button-cover">
                              <div className="buttonbtn r" id="button-1">
                                <input type="checkbox" className="checkbox" onChange={handleChangeDuration} />
                                <div className="knobs" />
                                <div className="layer" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tableContent px-2" style={{ overflowY: 'scroll', height: '250px' }}>
                <table className="table table-striped">
                  <thead style={{ backgroundColor: '#358696', color: '#fff' }}>
                    <tr>
                      <th scope="col">Vin</th>
                      <th scope="col">Mins</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(vehiclesDuration.length == 0) ? <NoTableData_Jupiter /> : vehiclesDuration.map(x => {
                      return (<tr key={x.key.vehicleId}>
                        <td scope="row" className="hand_geture" onClick={() => singleVinSelected(x.key.vehicleId)}>{x.key.vehicleId}</td>
                        <td>{x.chargeDurationInMin.value}</td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}
